import ZWideSection from './ZWideSection.vue'

export default ZWideSection
